import { atom } from "recoil";

export const tournamentsEditModalStore = atom({
	key: "tournamentsEditModalStore",
	default: {
		show: false,
		loaded: false,
		name: "",
		currentOption: {
			tournamentType: [{value: "sum_of_bets", label: "sum of bets"}, {value: "highest_coefficient", label: "highest coefficient",}, {value: "number_of_bets", label: "number of bets",}, {value: "sum_of_winnings", label: "sum of winnings"}],
			periodType: [{value: "daily", label: "daily"}, {value: "monthly", label: "monthly",}, {value: "weekly", label: "weekly",}],
			statusType: [{value: "active", label: "active"}, {value: "finished", label: "finished",}],
			translationType: [
				{ value: "internation", label: "internation" },
				{ value: "local", label: "local" },
			],
		},
		modalType: "",
		recurrence: "",
		tournamentType: "",
		translationType: "",
		periodType: "",
		game_ids: [],
		provider_ids: [],
		winners: "",
		prize_pool: "",
		from: "",
		to: "",
		min_bet: "",
		status: "",
		banner: null,
		slug: "",
		vip_level: null,
		deposit_count: "",
		promo_scope: "tournament_games",
		config_bot: {
			enabled: false,
			bots: [],
		},
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
